import React, { useRef, useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";

const MobileAppEnableDisableForm = (props) => {
  const frmRef = useRef({});
  const [allData, setAllData] = useState([]);
  const [checkedState, setCheckedState] = useState({});
  const [designationData, setDesignationData] = useState([]);
  
  const { sendRequest: getDesignation } = useHttp();

  useEffect(() => {
    getDesignation(
      {
        url: `/api/designation/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        // console.log(data);
        setDesignationData(data);
      }
    );
  }, [getDesignation]);


  const { sendRequest: getService } = useHttp();
  const { sendRequest: postDepartmentDetails } = useHttp();

  // Fetch Data
  const fillServiceDetail = (designationId) => {

    getService(
      {
        url: `/api/serviceDataEditPermissionList/?orgId=${localStorage.getItem(
          "orgId"
        )}&app_name=Procurement&designationId=${designationId}`,
      },
      (res) => {
        if (res) {
          setAllData(res.servicePermessionList);

          const initialCheckedState = {};
          res.servicePermessionList.forEach((employee, rowIndex) => {
            employee.serviceList.forEach((service) => {
              if (!initialCheckedState[service.serviceName]) {
                initialCheckedState[service.serviceName] = [];
              }
              initialCheckedState[service.serviceName][rowIndex] =
                service.status;
            });
          });
          setCheckedState(initialCheckedState);
        }
      },
      (error) => {
        console.error("Error fetching data:", error);
      }
    );
  };



  useEffect(() => {
    fillServiceDetail(0);
  }, [getService]);

  const handleHeaderCheckboxChange = (serviceName, isChecked) => {
    setCheckedState((prevState) => ({
      ...prevState,
      [serviceName]: new Array(allData.length).fill(isChecked),
    }));
  };

  const handleRowCheckboxChange = (rowIndex, serviceName, isChecked) => {
    setCheckedState((prevState) => ({
      ...prevState,
      [serviceName]: prevState[serviceName].map((status, index) =>
        index === rowIndex ? isChecked : status
      ),
    }));
  };

  const isHeaderChecked = (serviceName) => {
    return checkedState[serviceName]?.every((status) => status);
  };

  const isHeaderIndeterminate = (serviceName) => {
    const serviceState = checkedState[serviceName];
    return (
      serviceState?.some((status) => status) && !isHeaderChecked(serviceName)
    );
  };

  const submitHandler = (e) => {
    e.preventDefault();

    const data = {
      createdBy: parseInt(localStorage.getItem("id")),
      servicePermessionList: allData.map((employee, rowIndex) => ({
        empId: employee.empId,
        empName: employee.empName,
        orgId: parseInt(localStorage.getItem("orgId")),
        serviceList: employee.serviceList.map((service) => ({
          serviceDataEditPermissionId: service.serviceDataEditPermissionId,
          serviceId: service.serviceId,
          serviceName: service.serviceName,
          status: checkedState[service.serviceName]?.[rowIndex] ?? false,
          orgId: parseInt(localStorage.getItem("orgId")),
        })),
      })),
    };

    postDepartmentDetails(
      {
        url: "/api/serviceDataEditPermission/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      () => {
        toast.success("Permissions updated successfully");
        props.addForm(false);
      },
      (error) => {
        toast.error("Error updating permissions");
        console.error("Error:", error);
      }
    );
  };

  const handleSearch = (e) => {
    const filterText = e.target.value.trim().toLowerCase();
    const filteredData = allData.filter((item) =>
      item.empName.toLowerCase().includes(filterText)
    );
    setAllData(filteredData);
  };

  return (
    <div className="content-wrapper">
      <form style={{ margin: "10px" }} onSubmit={submitHandler}>
        <div className="card card-default">
          <div className="card-header">
            <h3 className="card-title">Mobile App Edit Enable/Disable</h3>
            <div className="card-tools">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => props.addForm(false)}
              >
                <i className="fas fa-times" />
              </button>
            </div>
          </div>
          <div className="card-body">
            <div className="row">
              
              <div className="col-3">
              <label htmlFor={"designation"}>{"Designation"}</label>
                        <select
                          id={"designation"}
                          required
                          ref={(el) => (frmRef.current["designation"] = el)}
                          className="form-control"
                           onChange={(e) => 
                           {
                            var id=0
                             if (e.target.value!="")
                             {
                               id=e.target.value
                             }
                             fillServiceDetail(id);
                           }}
                        >
                          <option value="">Select</option>
                          {designationData &&
                            designationData.map((x) => (
                              <option
                                key={x.designationId}
                                value={x.designationId}
                                selected={
                                  props.update &&
                                  x.designationId === props.update.designationId
                                }
                              >
                                {x.designationName}
                              </option>
                            ))}
                        </select>
                        </div>            

                        <div className="col-3">
                <label>Executive Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by name"
                  onKeyUp={handleSearch}
                />
              </div>
            </div>
            <div
              className="row"
              style={{
                overflowX: "auto",
                overflowY: "auto",
                maxHeight: "500px",
              }}
            >
              <table
                className="table table-bordered text-center"
                style={{ width: "100%" }}
              >
                <thead>
                  <tr>
                    <th
                      style={{
                        position: "sticky",
                        top: 0,
                        backgroundColor: "#fff",
                        zIndex: 99,
                      }}
                    >
                      Executive Name
                    </th>
                    {allData[0]?.serviceList.map((service) => (
                      <th
                        key={service.serviceName}
                        style={{
                          position: "sticky",
                          top: 0,
                          backgroundColor: "#fff",
                          zIndex: 99,
                          width: "200px",
                          height: "20px",
                          paddingRight: "35px",
                          textAlign: "center",
                          verticalAlign: "middle",
                        }}
                      >
                        {service.serviceName}
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={isHeaderChecked(service.serviceName)}
                          style={{ marginLeft: "5px" }}
                          ref={(el) =>
                            el &&
                            (el.indeterminate = isHeaderIndeterminate(
                              service.serviceName
                            ))
                          }
                          onChange={(e) =>
                            handleHeaderCheckboxChange(
                              service.serviceName,
                              e.target.checked
                            )
                          }
                        />
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {allData.map((employee, rowIndex) => (
                    <tr key={employee.empId}>
                      <td>{employee.empName}</td>
                      {employee.serviceList.map((service) => (
                        <td key={service.serviceName}>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            style={{
                              position: "sticky",
                              top: 0,
                              backgroundColor: "#fff",
                              zIndex: 1,
                            }}
                            checked={
                              checkedState[service.serviceName]?.[rowIndex] ||
                              false
                            }
                            onChange={(e) =>
                              handleRowCheckboxChange(
                                rowIndex,
                                service.serviceName,
                                e.target.checked
                              )
                            }
                          />
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div style={{ textAlign: "center" }}>
              <button className="btn btn-primary" type="submit">
                Submit
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default MobileAppEnableDisableForm;
